import "./Pages.css";

const TermsConditions = () => {
    return (
        <div className="terms-page">

            <div className="terms-container">

                <h1>Terms & Conditions</h1>

                {/* <p className="terms-updated">
                    Last Updated: September 11, 2026
                </p> */}

                <p>
                    Welcome to our website and services. By accessing or using
                    our website, products, or services, you agree to comply
                    with and be bound by these Terms & Conditions. Please read
                    these terms carefully before using our services.
                </p>

                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By accessing this website or using any of our services,
                        you acknowledge that you have read, understood, and
                        agreed to these Terms & Conditions. If you do not agree
                        with any part of these terms, please do not use our
                        website or services.
                    </p>
                </section>

                <section>
                    <h2>2. Our Services</h2>
                    <p>
                        We provide technology and communication solutions,
                        which may include:
                    </p>

                    <ul>
                        <li>E-commerce solutions</li>
                        <li>Order management systems</li>
                        <li>Inventory and business management solutions</li>
                        <li>SMS services</li>
                        <li>Email services</li>
                        <li>WhatsApp Business communication services</li>
                        <li>Business automation and integration services</li>
                        <li>Software development and technical services</li>
                    </ul>

                    <p>
                        Services may be modified, updated, suspended, or
                        discontinued at any time depending on business,
                        technical, or regulatory requirements.
                    </p>
                </section>

                <section>
                    <h2>3. User Responsibilities</h2>
                    <p>
                        You agree to use our website and services only for
                        lawful purposes. You are responsible for:
                    </p>

                    <ul>
                        <li>Providing accurate and complete information.</li>
                        <li>Maintaining the security of your account credentials.</li>
                        <li>Using our services in accordance with applicable laws.</li>
                        <li>Ensuring that your communications and content are lawful.</li>
                        <li>Obtaining appropriate consent before sending promotional communications.</li>
                    </ul>
                </section>

                <section>
                    <h2>4. E-commerce and Order Management Services</h2>
                    <p>
                        Our e-commerce and order management solutions may help
                        businesses manage products, customers, orders,
                        inventory, shipping, returns, and communications.
                    </p>

                    <p>
                        Customers are responsible for ensuring that the data
                        entered into the system is accurate. We are not
                        responsible for losses resulting from incorrect,
                        incomplete, or unauthorized information provided by
                        users.
                    </p>
                </section>

                <section>
                    <h2>5. SMS, Email and WhatsApp Services</h2>
                    <p>
                        Users must use SMS, email, and WhatsApp communication
                        services responsibly and in compliance with applicable
                        laws, regulations, and platform policies.
                    </p>

                    <p>
                        Users must not use our services to send spam,
                        fraudulent messages, misleading communications,
                        malicious content, or any content that violates
                        applicable laws or third-party platform policies.
                    </p>

                    <p>
                        We reserve the right to suspend or terminate messaging
                        services if we reasonably believe that they are being
                        misused.
                    </p>
                </section>

                <section>
                    <h2>6. Account Security</h2>
                    <p>
                        If you create an account with us, you are responsible
                        for keeping your login credentials confidential.
                        You should immediately notify us if you suspect
                        unauthorized access to your account.
                    </p>
                </section>

                <section>
                    <h2>7. Intellectual Property</h2>
                    <p>
                        Unless otherwise stated, the website, software,
                        designs, logos, text, graphics, documentation, and
                        other materials provided by us are our property or are
                        used under appropriate licenses.
                    </p>

                    <p>
                        You may not copy, reproduce, modify, distribute,
                        reverse engineer, or commercially exploit our
                        proprietary materials without prior written permission.
                    </p>
                </section>

                <section>
                    <h2>8. Third-Party Services</h2>
                    <p>
                        Our services may integrate with third-party providers,
                        including payment gateways, courier companies, SMS
                        providers, email providers, WhatsApp services, hosting
                        providers, and other external platforms.
                    </p>

                    <p>
                        Your use of third-party services may be subject to
                        their own terms, conditions, privacy policies, and
                        charges. We are not responsible for the independent
                        operation or policies of third-party services.
                    </p>
                </section>

                <section>
                    <h2>9. Payments and Charges</h2>
                    <p>
                        Certain services may require payment of applicable
                        subscription fees, usage charges, setup fees, or other
                        charges.
                    </p>

                    <p>
                        Applicable pricing and payment terms will be
                        communicated to the customer before the relevant
                        service is provided. Fees may be changed from time to
                        time with appropriate notice where applicable.
                    </p>
                </section>

                <section>
                    <h2>10. Service Availability</h2>
                    <p>
                        We make reasonable efforts to keep our services
                        available and operational. However, we do not
                        guarantee uninterrupted or error-free service.
                    </p>

                    <p>
                        Services may occasionally be unavailable due to
                        maintenance, upgrades, technical issues, network
                        failures, third-party services, or circumstances
                        beyond our reasonable control.
                    </p>
                </section>

                <section>
                    <h2>11. Data and Privacy</h2>
                    <p>
                        We may collect and process information necessary to
                        provide our services. The handling of personal
                        information is subject to our Privacy Policy.
                    </p>

                    <p>
                        Users are responsible for ensuring that any customer
                        information uploaded or processed through our systems
                        is collected and used lawfully and with appropriate
                        permissions.
                    </p>
                </section>

                <section>
                    <h2>12. Prohibited Activities</h2>
                    <p>You must not use our services to:</p>

                    <ul>
                        <li>Conduct fraudulent or illegal activities.</li>
                        <li>Send spam or unauthorized bulk communications.</li>
                        <li>Distribute malicious software or harmful content.</li>
                        <li>Attempt to gain unauthorized access to systems.</li>
                        <li>Interfere with the security or operation of our services.</li>
                        <li>Violate intellectual property or privacy rights.</li>
                        <li>Use the services for unlawful or deceptive purposes.</li>
                    </ul>
                </section>

                <section>
                    <h2>13. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by applicable law, we
                        shall not be liable for indirect, incidental, special,
                        consequential, or business losses arising from the use
                        or inability to use our services.
                    </p>

                    <p>
                        This includes losses resulting from service
                        interruptions, data errors, third-party service
                        failures, or unauthorized access beyond our reasonable
                        control.
                    </p>
                </section>

                <section>
                    <h2>14. Indemnification</h2>
                    <p>
                        You agree to indemnify and hold us harmless from claims,
                        losses, liabilities, damages, or expenses arising from
                        your misuse of our services, violation of these terms,
                        or violation of applicable laws or third-party rights.
                    </p>
                </section>

                <section>
                    <h2>15. Suspension or Termination</h2>
                    <p>
                        We may suspend or terminate access to our services if
                        you violate these Terms & Conditions, misuse our
                        services, fail to make required payments, or engage in
                        activities that may cause legal, security, or
                        operational risks.
                    </p>
                </section>

                <section>
                    <h2>16. Changes to These Terms</h2>
                    <p>
                        We may update these Terms & Conditions from time to
                        time. Updated terms will be posted on this page with a
                        revised "Last Updated" date.
                    </p>

                    <p>
                        Your continued use of our services after changes are
                        published constitutes acceptance of the updated terms.
                    </p>
                </section>

                <section>
                    <h2>17. Governing Law</h2>
                    <p>
                        These Terms & Conditions shall be governed by and
                        interpreted in accordance with the applicable laws of
                        India. Any disputes shall be subject to the
                        jurisdiction of the appropriate courts in India.
                    </p>
                </section>

                <section>
                    <h2>18. Contact Us</h2>
                    <p>
                        If you have questions about these Terms & Conditions,
                        please contact us through the contact details provided
                        on our website.
                    </p>
                </section>

            </div>

        </div>
    );
};

export default TermsConditions;